import { useNavigate } from 'react-router-dom';
import { Icon } from '../layout/Icon.jsx';
import { useAuth } from './useAuth.js';
import { useShiftStatus, useShiftUI } from './useShift.js';

/**
 * بوابة «لا يوجد شفت مفتوح» — تُلفّ بها شاشات البيع والنقد (الاستقبال،
 * المحاسبة، نقطة البيع، الكروت). الخادم يرفض العمليات أصلاً بدون شفت؛
 * هذه البوابة تمنع الموظف من ملء نموذج كامل ثم يُرفض عند الحفظ.
 */
export function ShiftGate({ children, what = 'البيع' }) {
  const navigate = useNavigate();
  const hasPermission = useAuth((s) => s.hasPermission);
  const { blocked } = useShiftStatus();
  const openModal = useShiftUI((s) => s.openModal);

  if (!blocked) return children;

  const canManage = hasPermission('shifts.view') || hasPermission('shifts.manage');

  return (
    <div className="card p-10 text-center max-w-xl mx-auto mt-6">
      <div className="mx-auto mb-3 w-16 h-16 rounded-full grid place-items-center" style={{ background: '#FFF7ED' }}>
        <Icon name="clock" size={32} color="#EA580C" />
      </div>
      <h2 className="text-[18px] font-extrabold m-0">لا يوجد شفت مفتوح</h2>
      <p className="text-ink-2 text-[13px] mt-2 leading-relaxed">
        يجب فتح شفت قبل {what}. عند الفتح تُسحب العهدة إلى درجك، وكل نقد تستلمه يُسجَّل
        على شفتك، وعند الإقفال يُعدّ الصندوق ويُرحَّل النقد المعدود.
      </p>
      <div className="flex gap-2 justify-center mt-5">
        <button type="button" className="btn btn-primary btn-lg" onClick={() => openModal('open')}>
          <Icon name="clock" size={16} /> فتح شفت الآن
        </button>
        {canManage ? (
          <button type="button" className="btn btn-lg" onClick={() => navigate('/shifts')}>
            إدارة الشفتات
          </button>
        ) : null}
      </div>
    </div>
  );
}
